import { render, staticRenderFns } from "./categoryPage.vue?vue&type=template&id=3b60cdbe"
import script from "@/assets/js/web/category.js?vue&type=script&lang=js&external"
export * from "@/assets/js/web/category.js?vue&type=script&lang=js&external"
import style0 from "@/assets/css/web/webAllStyle.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports